var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSalledattente(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 65.98 65.98",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;stroke:#e6007e;stroke-linecap:round;stroke-miterlimit:10;stroke-width:2px;}.cls-2{fill:#e6007e;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Calque_2",
    "data-name": "Calque 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1-2",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "salle_d_attente",
    "data-name": "salle d'attente"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M6.8,14.61A29.8,29.8,0,0,0,1,33,32,32,0,0,0,55.61,55.61a32,32,0,0,0,0-45.24h0A31.79,31.79,0,0,0,33,1a29.47,29.47,0,0,0-17.9,5.47"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M10.53,11.62a1.57,1.57,0,1,0-1.11-.46A1.57,1.57,0,0,0,10.53,11.62Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Waiting_room-2",
    "data-name": "Waiting room-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M13.69,52a.91.91,0,1,0,0,1.82h34a.91.91,0,0,0,0-1.82H43.12V47.43H49.5a.91.91,0,0,0,.92-.91V42.87A.92.92,0,0,0,49.5,42h-.91V35.57A4.56,4.56,0,0,0,44,31H40.38a4.56,4.56,0,0,0-4.56,4.56V42h-.91a.92.92,0,0,0-.92.91v.91H32.17v-.91a.91.91,0,0,0-.91-.91h-.92V35.57A4.56,4.56,0,0,0,25.78,31H22.13a4.56,4.56,0,0,0-4.56,4.56V42h-.91a.92.92,0,0,0-.92.91v3.65a.91.91,0,0,0,.92.91H23V52m14.6-16.43a2.74,2.74,0,0,1,2.74-2.74H44a2.74,2.74,0,0,1,2.74,2.74V42H37.64Zm-1.82,8.21H48.59v1.83H35.82ZM19.39,35.57a2.74,2.74,0,0,1,2.74-2.74h3.65a2.74,2.74,0,0,1,2.74,2.74V42H19.39Zm-1.82,8.21H30.34v1.83H17.57ZM24.87,52V47.43h6.39a.91.91,0,0,0,.91-.91v-.91H34v.91a.91.91,0,0,0,.92.91h6.38V52Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M51.33,52h-.91a.91.91,0,1,0,0,1.82h.91a.91.91,0,0,0,0-1.82Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M34,26.45a9.13,9.13,0,1,0-9.12-9.13A9.13,9.13,0,0,0,34,26.45ZM34,10a7.3,7.3,0,1,1-7.3,7.3A7.3,7.3,0,0,1,34,10Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.7,18.19l2.74.91a.92.92,0,0,0,1.16-.58A.91.91,0,0,0,37,17.37l-2.11-.71v-3.9a.92.92,0,0,0-1.83,0v4.56a.92.92,0,0,0,.62.87Z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalledattente);
export default __webpack_public_path__ + "static/media/salledattente.8d9dacf7e08080f6fee61d67d37bfc76.svg";
export { ForwardRef as ReactComponent };